import { withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const styles = theme => ({
  paper: {
    height: 100,
    width: 200,
    margin: "auto",
    marginTop: 20,
    marginBottom: 20,
    padding: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly"
    // boxShadow: "0 19px 38px rgba(0,0,0,0.30), 0 5px 20px rgba(0,0,0,0)"
  },
  numberIconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly"
  },
  sign: {
    fontSize: 13,
    // paddingTop: 20,
    fontWeight: "bold"
  },
  message: {
    fontSize: 13,
    // paddingLeft: 12,
    // paddingTop: 3,
    fontWeight: "bold"
  },
  calculatedNumber: {
    fontSize: 45
  },
  calculatedText: {
    fontSize: 18,
    fontWeight: "bold"
  }
});

class SummaryCard extends Component {
  render() {
    const { classes, calculatedNumber, calculatedText } = this.props;
    const { sign = "", message, icon } = this.props;
    const { iconSize = 40, iconColor = "#00bc84" } = this.props;
    return (
      <Paper className={classes.paper}>
        <div>
          <div className={classes.numberIconContainer}>
            <Grid className={classes.calculatedNumber}>
              {calculatedNumber}
              <span className={classes.sign}>{`${sign}`}</span>
            </Grid>
            {icon && (
              <FontAwesomeIcon
                icon={icon}
                style={{ fontSize: `${iconSize}`, color: `${iconColor}` }}
              />
            )}
          </div>
          <div>
            <Grid className={classes.message}>{message}</Grid>
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SummaryCard);



// WEBPACK FOOTER //
// ./src/components/FormElement/SummaryCard.js